import { render, staticRenderFns } from "./SupervisorRating.vue?vue&type=template&id=5edf64d8&scoped=true"
import script from "./SupervisorRating.vue?vue&type=script&lang=js"
export * from "./SupervisorRating.vue?vue&type=script&lang=js"
import style0 from "./SupervisorRating.vue?vue&type=style&index=0&id=5edf64d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edf64d8",
  null
  
)

export default component.exports